import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import SubActionButton from "@quest_editor/components/Buttons/SubActionButton";
import { useTranslation } from "react-i18next";

export type ProgressFilters = {
  promotionIdName: string;
  type: string;
  company: string;
  questIdName: string;
  dueDate: string;
};

const FilterSection = ({
  filters,
  onFilterChange,
  onSearch,
  promotionTypes,
  ownerTypes,
}: {
  filters: ProgressFilters;
  onFilterChange: (key: keyof ProgressFilters, value: string) => void;
  onSearch: () => void;
  promotionTypes: { value: string; label: string }[];
  ownerTypes: { value: string; label: string }[];
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      spacing={2}
      px={1}
      py={2}
    >
      <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
        <FormControl>
          <TextField
            variant="outlined"
            size="small"
            label={t("quest_progress_list.filter.promotion_id_name")}
            value={filters.promotionIdName}
            onChange={(e) => onFilterChange("promotionIdName", e.target.value)}
          />
        </FormControl>
        <FormControl size="small">
          <InputLabel id="type-filter-label">
            {t("quest_progress_list.filter.type.label")}
          </InputLabel>
          <Select
            labelId="type-filter-label"
            label={t("quest_progress_list.filter.type.label")}
            value={filters.type}
            onChange={(e) => onFilterChange("type", e.target.value)}
            sx={{ minWidth: 120 }}
          >
            <MenuItem value="">
              {t("quest_progress_list.filter.type.all")}
            </MenuItem>
            {promotionTypes.map((pt) => (
              <MenuItem key={pt.value} value={pt.value}>
                {pt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small">
          <InputLabel id="company-filter-label">
            {t("quest_progress_list.filter.company.label")}
          </InputLabel>
          <Select
            labelId="company-filter-label"
            label={t("quest_progress_list.filter.company.label")}
            value={filters.company}
            onChange={(e) => onFilterChange("company", e.target.value)}
            sx={{ minWidth: 120 }}
          >
            <MenuItem value="">
              {t("quest_progress_list.filter.company.all")}
            </MenuItem>
            {ownerTypes.map((ot) => (
              <MenuItem key={ot.value} value={ot.value}>
                {ot.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl>
          <TextField
            variant="outlined"
            size="small"
            label={t("quest_progress_list.filter.quest_id_name")}
            value={filters.questIdName}
            onChange={(e) => onFilterChange("questIdName", e.target.value)}
          />
        </FormControl>
        <FormControl>
          <TextField
            variant="outlined"
            size="small"
            type="date"
            label={t("quest_progress_list.filter.due_date")}
            value={filters.dueDate}
            onChange={(e) => onFilterChange("dueDate", e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </FormControl>
      </Stack>
      <SubActionButton onClick={onSearch}>
        {t("quest_progress_list.button.search")}
      </SubActionButton>
    </Stack>
  );
};

export default FilterSection;
